import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { StockService } from '../../services/stock.service';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Stock } from '../../model/Stock';
import { LoadService } from '../../services/load.service';
import { ClientsService } from '../../services/clients.service';
import { LocationService } from '../../services/location.service';
import { FilterUrlService } from '../../services/filter-url.service';
import * as moment from 'moment';

@Component({
  selector: 'app-stockcomercial',
  templateUrl: './stockcomercial.component.html',
  styleUrls: ['./stockcomercial.component.css']
})
export class StockcomercialComponent implements OnInit {
  @ViewChild(ModalDirective) lgModal: ModalDirective;
  public isopen:boolean;
  public alert:string;
  public load:number;
  public primeracarga:boolean;
  public stock_list:any;
  public links: any;
  public meta: any;
  public title = '';
  public signupForm: FormGroup;
  public item_to_update:number;
  public total_paginate:number;
  public total:number;
  public filter:string;
  public formDates:FormGroup;
  public settings = {
    columns:{
      po_number: {
        header: "Orden de Producción",
        type:"text",
        filter: { visible:true }
      },
      pr_code: {
        header: "Producto",
        type:"text",
        filter: { visible:true }
      },
      sp_code:{
        header:"Código Sernapesca",
        type:"text",
        filter:{visible:false}
      },
      pr_description:{
        header:"Descripción",
        type:"text",
        filter:{visible:false}
      },
      pr_group:{
        header:"Grupo",
        type:"text",
        filter:{visible:false}
      },
      lot_code: {
        header: "Proceso (Lote)",
        type:"text",
        filter: { visible:true }
      },
      pallet_code : {
        header: "Pallet",
        type:"text",
        filter: { visible:true }
      },
      elaboration_date: {
        header: "Fecha Congelación",
        type:"date",
        filter: { visible:true }
      },
      client: {
        header: "Cliente",
        type: "obj",
        filter: { visible:true,  id_type:'number', default:'asc', type:'dd' },
      },
      location:{
        header: "Ubicación",
        //cuando el elemento del filtro no es in input de texto, en este caso es un drop down
        type:"obj",
        // id_type: tipo de datos que se envia al backend, dd: dropdown
        filter: { visible:true,  id_type:'number',default:'asc', type:'dd' },
      },
      position: { header:"Posicion", type:"text", filter: { visible:true}},
      normal_box:{ header: "Numero de cajas", type:"number", filter:{visible:false}},
      total_normal_box:{ header: "Peso total caja normal", type:"text", filter:{visible:false} },
      residue_box:{ header: "Numero de saldos", type:"text", filter:{visible:false} },
      total_residue:{ header: "Peso total de saldos", type:"text", filter:{visible:false} },
      total:{header:"Kilos Totales", type:"text", filter:{visible:false}},
      created_at:{header:"Fecha Movimiento", type:"date", path:"attributes.created_at", filter:{visible:false}}
      // observations:{header:"Observaciones", type:"text"},
      // status:{header:"Estado", type:"text"},
      // block_reason:{header:"Razón de Bloqueo", type:"text"}
    },
    actions:{
      edit: false,
      view: false,
      delete: false
    }
  };

  constructor(private _stockService:StockService,
    private _loaddata: LoadService,
    private _clientes: ClientsService,
    private _location: LocationService,
    private _filter: FilterUrlService) {
      this.stock_list = [];
      this.primeracarga = false;
      this.total_paginate = 0;
      this.total = 0;
      this.formDates = new FormGroup({
        'inicio_date':new FormControl('',Validators.required),
        'termino_date':new FormControl('',Validators.required)
      });
    }

    ngOnInit() {
      this._loaddata.loadChange(15);

      //Carga filtro inicial
      this._filter.filterFirstLoad(this.settings);
      this._filter.filters.subscribe(new_filter => this.filter = new_filter );
      this._loaddata.loadCurrent.subscribe(a=> this.load = a);
      this.getClientes();
    }

  // obtener los datos para filtro de clientes
  //carga de datos para los filtros con dropdown
  public getClientes(){
    this.alert = 'Cargando clientes.';
    this.isopen = true;
    this._loaddata.loadChange(40);

    this._clientes.getAll().subscribe(
      (response:any) => {
        let data = response.data;
        let clientes:string = "{";
        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            clientes+='"'+data[key].id+'":"'+data[key].attributes.name+'",';
          }
        }
        clientes = clientes.slice(0,-1);
        clientes+="}";
        this.settings.columns.client.filter['data'] = clientes;
        this.getUbicaciones();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  // obtener los datos para filtro de ubicaciones
  //carga de datos para los filtros con dropdown
  getUbicaciones(){
  this.alert = 'Cargando ubicaciones.';
  this.isopen = true;
  this._loaddata.loadChange(60);

  this._location.getAll().subscribe(
    (response:any) => {
      let data = response.data;
      let location:string = "{";
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          location+='"'+data[key].id+'":"'+data[key].attributes.name+'",';
        }
      }
      location = location.slice(0,-1);
      location+="}";
      this.settings.columns.location.filter['data'] = location;
      this.loadData();
    },
    (error) => {
      this.showError(error.error.error);
    }
  );
  }

  /*busca los datos con respecto a los filtros seleccinados (recibe una url con las columnas y valores)*/
  loadDataFiltered(filters){
  //console.log('FILTROS: ', filters);
  this.actualizarFiltroConFechas(filters);
  this.isopen = false;
  this._loaddata.loadChange(50);
  this._stockService.getDataFiltered3(this.filter).subscribe(
    (response:any) => {
      //console.log("Respuesta del filtro", response);
      this.stock_list = response.data;
      this.stock_list = this.formatDate(this.stock_list);
      this.links = response.links;
      this.meta = response.meta;
      if(response.data.length == 0){
         this.total_paginate = 0;
         this.total = 0;
      }
      else{
        this.total_paginate = response.calculated.total_paginate;
        this.total = response.calculated.total;
      }

      this._loaddata.loadChange(100);
      this.alert = "Carga Correcta."
      this.isopen =true;
      this.onClosedAutomatic();
      if(this.primeracarga === false){
        this.primeracarga = !this.primeracarga;
      }
    },
    (error) => {
      if(error.status == 0){
        this.alert = 'Busqueda sin resultados.';
        this.onClosedAutomatic();
      }
      else{
        this.showError(error.error.error);
      }
    }
  );
  }

  loadData(){
  this._loaddata.loadChange(70);
  this.alert = 'Cargando stock.';
  this.isopen = true;
  this._filter.changeFilters("?commercial=1");
  let that = this;

  this._stockService.getStockSummary2(this.filter).subscribe(
    (response:any) => {
      //console.log('Respuesta lista stock: ',response);
      if(this.primeracarga === false){
        this.primeracarga = !this.primeracarga;
      }
      this.stock_list = response.data;
      this.stock_list = this.formatDate(this.stock_list);

      //console.log("Lista Stock ",this.stock_list);

      this.links = response.links;
      this.meta = response.meta;
      this.total_paginate = response.calculated.total_paginate;
      this.total = response.calculated.total;
      //console.log("totales primera carga: total_paginate: "+this.total_paginate + "total: "+this.total);
      this.alert = 'Stock cargado.';
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
      // setTimeout(function(){
      //   that.isopen = false;
      // }, 5000);
    },
    (error) =>{
      this.showError(error.error.error);
    }
  );
  }

  actualizarFiltroConFechas(filters){
  //console.log("filtro recibido",filters);
  let filtro_nuevo = ``;
  let from = this.formDates.get('inicio_date').value;
  let to = this.formDates.get('termino_date').value;
  let f = moment(from).format("YYYY-MM-DD");
  let t = moment(to).format("YYYY-MM-DD");
  //console.log("From: ",from);
  //console.log("To: ",to);

  if(filters.length > 0){
    /*si el filtro ya contiene parametros*/
    let contain_symbol  = filters.includes('?from=');
    let contain_griega = filters.includes('&from=');
    if(contain_symbol){
      /*si contiene el simbolo de interrogación seguido del from (quiere decir que no hay ningun filtro mas que las fechas)*/
      filtro_nuevo = `?from=${f}&to=${t}&commercial=1`;
      this._filter.changeFilters(filtro_nuevo);
      //console.log("FILTRO SOLO CON FECHAS:",this.filter);
    }
    else if(contain_griega){
      /*si ya contiene un rango de fechas*/
      //console.log("SI AQUI");
      /*separando el &from*/
      let array_from = filters.split("&from=");
      let parte_1 = array_from[0];
      let fin_parte_2 = array_from[1].length;
      let parte_2 = array_from[1].slice(10,fin_parte_2);

      let filtro_from_actualizado = `${parte_1}&from=${f+parte_2}`;
      //console.log("filtro from actualizado:",filtro_from_actualizado);
      /*separando el &to*/
      let array_to = filtro_from_actualizado.split("&to=");
      let parte_1_final = array_to[0];
      let fin_parte_2_final = array_to[1].length;
      let parte_2_final = array_to[1].slice(10,fin_parte_2_final);

      filtro_nuevo = `${parte_1_final}&to=${t+parte_2_final}`;
      this._filter.changeFilters(filtro_nuevo);
      //console.log("FECHAS ACTUALIZADAS PLEASE :'( ",this.filter);

    }
    else if(!filters.includes("commercial=1")){
      if(f!=''&&t!='' && f!='Invalid date' && t!='Invalid date'){
        filtro_nuevo = `${filters}&from=${f}&to=${t}&commercial=1`;
      }
      else{
        filtro_nuevo = `${filters}&commercial=1`;
      }

      this._filter.changeFilters(filtro_nuevo);
      //console.log("nueva condicion:",this.filter);
    }
    else{
      /*no contiene un rango de fechas pero si tiene filtros aplicados*/
      if(f != 'Invalid date' && t != 'Invalid date'){
        if(filters.includes("commercial=1")){
          filtro_nuevo = `${filters}&from=${f}&to=${t}`;
        }
        else{
          filtro_nuevo = `${filters}&from=${f}&to=${t}&commercial=1`;
        }

        this._filter.changeFilters(filtro_nuevo);
        //console.log("FILTRO NO TIENE RANGO FECHAS PERO SI FILTROS:",this.filter);
      }

    }
  }
  else{
    /*el filtro no contiene parametros*/
    filtro_nuevo = `?from=${f}&to=${t}&commercial=1`;
    this._filter.changeFilters(filtro_nuevo);
    //console.log("FILTRO VACIO:",this.filter);
  }
  }

  public filtrarFecha(){

  this.loadDataFiltered(this.filter);

  }

  onGenerateExcel(){
  this.alert = "Generando Excel.";
  this.isopen = true;
  this._loaddata.loadChange(30);
  window.open(this._stockService.getExcel(), "_blank");
  this.alert = "Excel generado.";
  this._loaddata.loadChange(100);
  }

  onGenerateExcel2(){
  this.alert = "Generando Excel.";
  this.isopen = true;
  this._loaddata.loadChange(30);
  window.open(this._stockService.getExcel2(), "_blank");
  this.alert = "Excel generado.";
  this._loaddata.loadChange(100);
  }
  /*esta funcion recibe los datos de la actualización por paginación*/
  updateData(response:any){
  this.stock_list = response.data;
  this.stock_list = this.formatDate(this.stock_list);
  this.total_paginate = response.calculated.total_paginate;
  this.total = response.calculated.total;
  // this.stock_list = data;
  // let suma = 0;
  //console.log("Datos de Actualizacion de Pagina: ", data.attributes.total);
  // for(let item of this.stock_list){
  //        suma = suma + item.attributes.total;
  // }
  // this.total_paginate = suma;
  //console.log("Respuesta de la paginacion de Stock: ", response);
  }


  /*formatea la fecha*/
  formatDate(stock_list:any){
  for(let stock of stock_list){
    let fecha = stock.attributes.created_at.date;
    let fechArray = fecha.split('.');
    let fecha2 = fechArray[0];


    stock.attributes.created_at = fecha2;
  }
  return stock_list;
  }

  /**
  * carga la informacion de una fila en el formulario
  * @param index indice de la fila
  */
  showViewForm(index):void {
  this.showChildModal();
  }

  showChildModal(): void {
  this.lgModal.show();
  }

  hideChildModal(): void {
  this.lgModal.hide();
  }

  /**
  * Cierra el mensaje de alerta.
  */
  onClosed(): void {
  this.isopen = false;
  }

  /*
  * Cierra el mensaje de alerta despues de 3 segundos
  */
  onClosedAutomatic(): void {

    setTimeout(()=>{
    this.isopen = false;
  }, 3000);

  }

  /**
  * Muestra un error
  * @param  msg mensaje del error
  */
  showError(msg:string){
  if(msg == undefined){
    this.alert = 'No tiene permisos para realizar la acción.';
  }
  else{
    this.alert = msg;
  }
  this._loaddata.loadChange(100);
  this.isopen =true;
  }

  handler(type: string, $event: ModalDirective) {
  if (type === 'onHide'){
  }
  }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/stockcomercial/stockcomercial.component.ts